import { render, staticRenderFns } from "./DisplayCurrencyPrice.vue?vue&type=template&id=034f20e4"
import script from "./DisplayCurrencyPrice.vue?vue&type=script&lang=js"
export * from "./DisplayCurrencyPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports